module.exports = __webpack_public_path__ + "img/proapp-3.db0bfa7a.webp";